import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '../services/HttpClientServices/Http.service';
import { UserInfo } from 'src/app/userInfo';
import { ChatNavBarService } from './ChatNavBarService';
import { SignalRHelperService } from '../services/SignalRHelper.service';
import { INotificationOption, NotificationService } from 'BI-Libraries/BI-Components/projects/bi-modules/src/lib/services/notification.service';

@Component({
  selector: 'chat-nav-bar',
  templateUrl: './chat-nav-bar.component.html',
  styleUrl: './chat-nav-bar.component.scss'
})
export class ChatNavBarComponent {
  constructor(private _router: Router,private httpService:HttpService,public chatNavBarService:ChatNavBarService,
    private notificationService: NotificationService,private signalRService: SignalRHelperService){
    this.httpService.get(`SV_CHAT_LastMessage?$filter=RecipientID eq '${UserInfo.UserCode}' and UnreadMessagesCount ne 0&$select=SenderID&$count=true`).subscribe(res=>{
      chatNavBarService.ChatNumber = res.value.length;
      res.value.forEach(Recepient => {
        this.chatNavBarService.Recipients.add(Recepient.SenderID);
      });
    })
  }
  ngOnInit(){
    
    this.signalRService.messageReceived.subscribe((Message: any) => {
      if(!this.chatNavBarService.Recipients.has(Message.senderID)){
        this.chatNavBarService.ChatNumber++;
        this.chatNavBarService.Recipients.add(Message.senderID);
      }
      var notificationOptions: INotificationOption = {
        Title: 'New Message',
        Body: `${Message.content}`,
        Icon: 'assets/images/loading-buzz-logo.png',
        OnClick: () => {
            this._router.navigate(['SupervisorBeta/chat']) 
        }
      }
      this.notificationService.notifyMe(notificationOptions)
    });
  }
  ChatClick() {
    this._router.navigate(['/SupervisorBeta/chat']);
  }
}
